import { render, staticRenderFns } from "./StudentAdditionalLangReport.vue?vue&type=template&id=5cafe203&scoped=true"
import script from "./StudentAdditionalLangReport.vue?vue&type=script&lang=js"
export * from "./StudentAdditionalLangReport.vue?vue&type=script&lang=js"
import style0 from "./StudentAdditionalLangReport.vue?vue&type=style&index=0&id=5cafe203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cafe203",
  null
  
)

export default component.exports